<script>
import { orderBy } from 'lodash'
import baseMixin from '@/mixins/baseMixin'
import ClientBookingStatus from '@/shared/constants/booking/ClientBookingStatus'
import featureFlagMixin from '@/mixins/featureFlagMixin'
import BookingCardOld from '../booking-card.vue'
import BookingCard from '../booking-card-v2.vue'

export default {
  name: 'BookingSummaryCardList',
  components: { BookingCard, BookingCardOld },
  mixins: [baseMixin, featureFlagMixin],
  props: {
    bookings: {
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      bookingSortOrderByStatus: [
        ClientBookingStatus.unfilled,
        ClientBookingStatus.tentative,
        ClientBookingStatus.filled,
        ClientBookingStatus.pendingApproval,
        ClientBookingStatus.rejected,
      ],
    }
  },
  computed: {
    isLoading() {
      return this.loadingCount > 0
    },
    calcBookingCardColumnBreakpoints() {
      return {
        sm: 12,
        md: this.selfServiceFeatureFlags.showBookingCardV2 ? 6 : 12,
        xl: this.selfServiceFeatureFlags.showBookingCardV2 ? 4 : 12,
      }
    },
  },
  methods: {
    viewCandidate(value) {
      this.$emit('viewCandidate', value)
    },
    cancelBooking(value) {
      this.$emit('cancelBooking', value)
    },
    orderedBookings(bookings) {
      return orderBy(bookings, (booking) =>
        this.bookingSortOrderByStatus.indexOf(booking.status)
      )
    },
  },
}
</script>

<template>
  <div>
    <div
      v-for="location in bookings"
      :key="`booking-summary-card__location-${location.locationId}`"
    >
      <p class="subtitle-2 font-weight-medium mt-4 mb-8">
        {{ location.locationName }}
      </p>

      <v-row>
        <v-col
          v-for="booking in orderedBookings(location.bookings)"
          :key="`bookingcard_${booking.id}`"
          v-bind="calcBookingCardColumnBreakpoints"
        >
          <BookingCard
            v-if="selfServiceFeatureFlags.showBookingCardV2"
            :booking="booking"
            @viewCandidate="viewCandidate"
            @cancelBooking="cancelBooking"
          />
          <BookingCardOld
            v-else
            :booking="booking"
            @viewCandidate="viewCandidate"
            @cancelBooking="cancelBooking"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
